import React, { forwardRef, PropsWithChildren } from "react";
import PropTypes from "prop-types";
import type { ReactComponentStaticProps } from "../../types/react";

import { NavTileHeading } from "./NavTileHeading";
import { NavTileCopy } from "./NavTileCopy";
import { NavTileLink } from "./NavTileLink";

import styles from "./ContentTileNavigation.scss";

export type NavTileProps = PropsWithChildren<{}>;

const NavTileWithRef = (
  props: NavTileProps,
  ref: React.ComponentPropsWithRef<"div">["ref"]
) => {
  const { children, ...others } = props;
  return (
    <div className={styles.navItem} ref={ref} {...others}>
      {children}
    </div>
  );
};

export const NavTile = (forwardRef(NavTileWithRef) as unknown) as ((
  props: NavTileProps
) => ReturnType<typeof NavTileWithRef>) &
  Required<ReactComponentStaticProps<NavTileProps>> & {
    Heading: typeof NavTileHeading;
    Copy: typeof NavTileCopy;
    Link: typeof NavTileLink;
  };

NavTile.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

NavTile.Heading = NavTileHeading;
NavTile.Copy = NavTileCopy;
NavTile.Link = NavTileLink;

NavTile.displayName = "ContentTileNavigation.Item";

export default NavTile;
